import { type OrderItemCatalogItemApiModel } from '../api-models/OrderItemCatalogItemApiModel'

/**
 * `locked` folds the absent `rfo_lock` to `false` — the response does not carry
 * it yet, so every item reads unlocked until the backend adds it.
 */
export const mapOrderItemCatalogItem = (
  catalogItem: Nullable<OrderItemCatalogItemApiModel>
) =>
  catalogItem
    ? {
        id: catalogItem.id,
        name: catalogItem.name,
        locked: catalogItem.rfo_lock ?? false,
      }
    : null
